import { errorNoti } from "../../../../base/BasicNotifications";
import { getErrorMessage } from "../_store/okrPlansCoachStore";

// Failures only, with the BE `message` (BE §2.0). CD27: no success toasts —
// a change shows on the screen itself.
export const notifyError = (err) =>
  errorNoti(typeof err === "string" ? err : getErrorMessage(err));
